import { useState, useEffect } from 'react';
import { getCcv2CurrentUser } from '../services/callcenterV2';

/**
 * Returns current user info including role derived from JWT.
 * Syncs on mount only (token doesn't change mid-session).
 */
export function useCurrentUser() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    try {
      setUser(getCcv2CurrentUser());
    } catch (_e) {
      setUser({ role: 'user', isManager: false, isRoot: false, idtenant: '', username: '', agentKey: null, userId: null });
    }
  }, []);

  return user;
}

/**
 * Returns true if current user has any of the given roles.
 * @param {string[]} roles
 */
export function useHasRole(...roles) {
  const user = useCurrentUser();
  if (!user) return false;
  return roles.includes(user.role);
}

/**
 * Feature-flag hook for Phase 5.
 * @returns {{ enabled: boolean, toggle: () => void }}
 */
export function usePhase5Flag() {
  const [enabled, setEnabled] = useState(() => {
    const stored = localStorage.getItem('ccv2_phase5_ui');
    if (stored !== null) return stored === 'true';
    return false;
  });

  const toggle = () => {
    const next = !enabled;
    localStorage.setItem('ccv2_phase5_ui', String(next));
    setEnabled(next);
  };

  return { enabled, toggle };
}
